<template>
  <form
    ref="form"
    data-url="/accreditationtechnical/evaluationTeamDesignation/designationReport/update"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Evaluadores</h5>
      </legend>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Función/Rol</th>
              <th scope="col">Evaluador</th>
              <th scope="col">Institución</th>
              <th scope="col">Estado</th>
              <th scope="col" class="text-center">Agregar documento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, i) in evaluadores" :key="i">
              <td class="align-middle">
                {{ value.evaluator_type.value }}
              </td>
              <td class="align-middle">
                {{ value.evaluator.first_name }} {{ value.evaluator.last_name }}
              </td>
              <td class="align-middle">
                {{ value.evaluator.institution }}
              </td>
              <td class="align-middle">
                <span
                    class="badge badge-sm badge-pill badge-warning"
                    v-if="value.is_confirmed == null"
                    >Pendiente de aceptación</span
                  >
                  <span
                    class="badge badge-sm badge-pill badge-danger"
                    v-if="value.is_confirmed == 0"
                    >Rechazado</span
                  >
                  <span
                    class="badge badge-sm badge-pill badge-success"
                    v-if="value.is_confirmed == 1"
                    >Aceptado</span
                  >
              </td>
              <td class="align-middle text-center">
                <app-input
                  :id="`file_${i}`"
                  type="file"
                  :label="value.file ? value.file.name : $t('upload_your_file')"
                  v-model="value.file"
                  :disabled="disabledsupport"
                  v-if="!value.evaluation_team_designation"
                  @change="onChange($event, value)"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(value, 'evaluation_team_designation')
                    "
                    v-if="value.evaluation_team_designation"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
                <div class="mt-2" v-if="!disabledsupport">
                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="deleteFile(i)"
                    v-if="value.evaluation_team_designation"
                    :disabled="value.is_confirmed == 1"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-2" v-if="observations.length > 0">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Observaciones</h5>
      </legend>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Usuario</th>
              <th scope="col">Fecha</th>
              <th scope="col">Observación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, i) in observations" :key="i">
              <td class="align-middle">
                {{ value.first_name }} {{ value.last_name }}
              </td>
              <td class="align-middle">
                {{ value.created_at.slice(0, 10) }}
              </td>
              <td class="align-middle">
                {{ value.observation }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-if="showRiskMatrix">
      <legend
        class="col-12 col-form-label text-primary pt-0 mb-3"
        v-if="showRiskMatrix"
      >
        <h5 class="text-primary">
          Matríz de riesgo <b class="text-danger">*</b>
        </h5>
      </legend>
      <div class="col-6">
        <div class="form-group">
          <label>Matriz de riesgo:</label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            :disabled="disabledsupport"
            v-if="!inputs.risk_matrix"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'risk_matrix')"
              v-if="inputs.risk_matrix"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('risk_matrix')"
              :disabled="disabledsupport"
              v-if="inputs.risk_matrix"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Mostrar unicamente si es EVALUACION de tipo Inspeccion o Certificacion-->
    <!--
    <div class="row" v-if="showRiskMatrix">
      <legend
        class="col-12 col-form-label text-primary pt-0 mb-3"
        v-if="showRiskMatrix && showInputFile"
      >
        <h5 class="text-primary">
          Puntos de la norma a evaluar<b class="text-danger">*</b>
        </h5>
      </legend>
    </div>
    <div class="row" v-if="showRiskMatrix && showInputFile">
      <div class="col-6">
        <div class="form-group">
          <label>Puntos de la norma a evaluar:</label>
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            :required="true"
            v-if="!inputs.standard_evaluate"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'standard_evaluate')"
              v-if="inputs.standard_evaluate"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('standard_evaluate')"
              v-if="inputs.standard_evaluate"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div> 
    -->
    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          :disabled="disabledsupport"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import {
  axiosGet,
  axiosPost,
} from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      evaluadores: "",
      report: "",
      showFile: false,
      showRiskMatrix: false,
      showInputFile: false,
      observations: [],
      disabledsupport: false,
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
    this.data();
    this.dataAcc();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    data() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/planningteam/planningEvaluation/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        
        this.evaluadores = response.data.evaluadores;
        this.showFile = response.data.showFile;
        this.observations = response.data.observations;
      });
    },

    dataAcc() {
      this.preloader = true;
      let url = `/accreditations/session/showauth/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (response?.data) {
              //id session
              axiosGet(
                  `/accreditations/session/getauth`
                )
                  .then((rsession) => {
                    if (rsession.status == 200) {
                      if (response.data.support_technique == rsession.data && response.data.responsible_technician != response.data.support_technique) {
                        this.disabledsupport = true;
                      } else {
                        this.disabledsupport = false;
                      }
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  })
                  .finally(() => {});
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    onChange($event, value) {
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/evaluationTeamDesignation/designationReport/store`;
      let formData = new FormData();
      formData.append("file", $event.target.files[0]);
      for (const [key, value] of Object.entries(value)) {
        formData.append(key, value);
      }

      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          this.$toastr.s(this.$t("updated_success"));
          this.data();
        })
        .catch(({ error }) => {});
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },
    submit() {
      let formData = new FormData();
      formData.append(
        "eval_test_id",
        this.$store.state.evaluatorReview.evalTestId
      );
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    deleteFile(pos) {
      this.evaluadores[pos].evaluation_team_designation = null;
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/evaluationTeamDesignation/designationReport/show/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url)
        .then((res) => {
          this.inputs = res.data;
          var area = res.data.accreditation_applications.accreditation_area.name;
          var type = res.data.type;
          var area =
            res.data.accreditation_applications.accreditation_area.name;
          if (type == "E") {
            if(area == 'LABORATORIOS'){
              this.showRiskMatrix = false;
            }else{
              this.showRiskMatrix = true;
            }
            
          }
          // Verificar si la solicitud es de Inspeccion o Certificado :: mostrar el input file.
          if (area == "INSPECCIÓN" || area == "CERTIFICACIÓN") {
            this.showInputFile = true;
          }
        })
        .catch(({ error }) => {});
    },
  },
};
</script>
